<template>
    <div v-html="info" id = "bodyText">
        
    </div>
</template>

<script>
import api from '../../services/api'
import moment from 'moment'

export default {
    data() {
        return {
            info: ''
        }
    },
    async created() {
        const infoApi = api('information')
        this.info = await infoApi.get()
    }
}
</script>

<style>
    #bodyText{
        padding: 20px; 
        margin:0 20px;
        text-align: left;
    }
</style>